import React from 'react';
import { useTranslation } from 'react-i18next';
import { ZenModeTooltip } from 'components/ZenModeTooltip';
import { StreamControlButton } from 'features/streaming/components/StreamControlButton';
import { LOCAL_MUTE_ICONS } from 'features/local-mute/icons';
import { useIsLocallyMuted } from 'features/local-mute/useIsLocallyMuted';
import { userUnmutedLocally } from 'features/local-mute/localMuteSlice';
import { useAppDispatch } from 'store/hooks';
import { UserId } from 'features/users/types';

const TileLocalMuteIndicator = ({ userId }: { userId: UserId }) => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();

  const isLocallyMuted = useIsLocallyMuted(userId);

  if (!isLocallyMuted) {
    return null;
  }

  const label = t('tooltips.unmute_for_me');

  return (
    <ZenModeTooltip title={label} placement="top">
      <StreamControlButton
        icon={LOCAL_MUTE_ICONS.muteForMe}
        aria-label={label}
        onClick={() => dispatch(userUnmutedLocally(userId))}
      />
    </ZenModeTooltip>
  );
};

export default TileLocalMuteIndicator;
